module.exports = __webpack_public_path__ + "img/back-arrow.242f96b6.svg";